import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { BaseControl, TypeChecker } from '../../../shared';



@Component({
  selector: 'app-text-control',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    InputTextModule
  ],
  template: `
    <div [formGroup]="formGroup" *ngIf="typeChecker.isInputText(control)" class="w-full">
        <input pInputText type="text" [formControlName]="control.name" class="w-full"
            [attr.aria-describedby]="control.name + '-help'" 
            [placeholder]="typeChecker.hasPlaceholder(control) ? control.placeholder : ''"
            [readonly]="control.readonly"/>
    </div> 
  `,
  styles: `
    :host {
      display: contents;
    }
  `
})
export class TextControlComponent {
  @Input() control !: BaseControl<any>;
  @Input() formGroup !: FormGroup;

  typeChecker = TypeChecker;
}
